import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router"
import Login from "@/views/Login.vue"
import ForgotPassword from "@/views/ForgotPassword.vue"
import Profile from "@/views/Profile.vue"
import Home from "@/views/Home.vue"
import CompanyReportRPKList from "@/views/CompanyReportRPKList.vue"
import CompanyReportRPKDetails from "@/views/CompanyReportRPKDetails.vue"
import CompanyReportCWKList from "@/views/CompanyReportCWKList.vue"
import CompanyReportCWKDetails from "@/views/CompanyReportCWKDetails.vue"
import CompanyReportCWKConfiguration from "@/views/CompanyReportCWKConfiguration.vue"
import JournalList from "@/views/JournalList.vue"
import JournalDetails from "@/views/JournalDetails.vue"
import JournalEntityDetails from "@/views/JournalEntityDetails.vue";

import UserList from "@/views/admin/UserList.vue"
import UserDetails from "@/views/admin/UserDetails.vue"
import CompanyList from "@/views/admin/CompanyList.vue"
import CompanyDetails from "@/views/admin/CompanyDetails.vue"
import ConsoGroupList from "@/views/admin/ConsoGroupList.vue";
import ConsoGroupDetails from "@/views/admin/ConsoGroupDetails.vue";
import PurposeList from "@/views/admin/PurposeList.vue"
import PurposeDetails from "@/views/admin/PurposeDetails.vue"
import SheetList from "@/views/admin/SheetList.vue"
import SheetDetails from "@/views/admin/SheetDetails.vue"
import TemplateEditor from "@/views/admin/template_editor/TemplateEditor.vue"
import AccountList from "@/views/admin/AccountList.vue"
import AccountDetails from "@/views/admin/AccountDetails.vue"
import CountryList from "@/views/admin/CountryList.vue"
import CountryDetails from "@/views/admin/CountryDetails.vue"
import CurrencyList from "@/views/admin/CurrencyList.vue"
import CurrencyDetails from "@/views/admin/CurrencyDetails.vue"
import CurrencyExchangeRate from "@/views/admin/CurrencyExchangeRate.vue"
import EliminationSettingList from "@/views/admin/EliminationSettingList.vue"
import EliminationSettingDetails from "@/views/admin/EliminationSettingDetails.vue"
import Setting from "@/views/admin/Setting.vue"

import Approval from "@/views/approval/Approval.vue"

import ReportList from "@/views/reporting/ReportList.vue"
import ReportGenerate from "@/views/reporting/ReportGenerate.vue"

import AuditLog from "@/views/auditlog/AuditLog.vue"

import store from "@/store"


const routes: Array<RouteRecordRaw> = [
	{
		path: "/login",
		component: Login,
		meta: {
			title: "Login"
		}
	},
	{
		path: "/forgotpassword",
		component: ForgotPassword,
		meta: {
			title: "Forgot Password"
		}
	},
	{
		path: "/profile",
		component: Profile,
		meta: {
			requiresAuth: true,
			module: "Profile",
			title: "Profile"
		}
	},
	{
		path: "/home",
		component: Home,
		meta: {
			requiresAuth: true,
			module: "Home",
			title: "Home",
		}
	},
	{
		path: "/companyreport/rpk",
		component: CompanyReportRPKList,
		meta: {
			requiresAuth: true,
			module: "RPK",
			title: "RPK"
		}
	},
	{
		path: "/companyreport/rpk/add",
		component: CompanyReportRPKDetails,
		meta: {
			requiresAuth: true,
			module: "RPK",
			title: "RPK Details"
		}
	},
	{
		path: "/companyreport/rpk/view/:id",
		component: CompanyReportRPKDetails,
		props: (route) => ({
			created: route.query.created == 'true'
		}),
		meta: {
			requiresAuth: true,
			module: "RPK",
			title: "RPK Details"
		}
	},
	{
		path: "/companyreport/cwk",
		component: CompanyReportCWKList,
		meta: {
			requiresAuth: true,
			module: "CWK",
			title: "CWK",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"},
				{role: "Viewer"}
			]
		}
	},
	{
		path: "/companyreport/cwk/add",
		component: CompanyReportCWKDetails,
		meta: {
			requiresAuth: true,
			module: "CWK",
			title: "CWK Details",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/companyreport/cwk/view/:id",
		component: CompanyReportCWKDetails,
		meta: {
			requiresAuth: true,
			module: "CWK",
			title: "CWK Details",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"},
				{role: "Viewer"}
			]
		}
	},
	{
		path: "/companyreport/cwk/view/:id/configuration",
		component: CompanyReportCWKConfiguration,
		meta: {
			requiresAuth: true,
			module: "CWK",
			title: "CWK Configuration",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"},
				{role: "Viewer"}
			]
		}
	},
	{
		path: "/journal",
		component: JournalList,
		meta: {
			requiresAuth: true,
			module: "Journal",
			title: "Journal",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"},
				{role: "Viewer"}
			]
		}
	},
	{
		path: "/journal/add",
		component: JournalDetails,
		meta: {
			requiresAuth: true,
			module: "Journal",
			title: "Journal Details",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/journal/:id",
		component: JournalDetails,
		meta: {
			requiresAuth: true,
			module: "Journal",
			title: "Journal Details",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"},
				{role: "Viewer"}
			]
		}
	},
	{
		path: "/journal/:id/add",
		component: JournalEntityDetails,
		meta: {
			requiresAuth: true,
			module: "Journal",
			title: "Journal Entity Details",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/journal/:id/view/:entityId",
		component: JournalEntityDetails,
		meta: {
			requiresAuth: true,
			module: "Journal",
			title: "Journal Entity Details",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"},
				{role: "Viewer"}
			]
		}
	},
	{
		path: "/reporting/report",
		component: ReportList,
		meta: {
			requiresAuth: true,
			module: "Report",
			title: "Report"
		}
	},
	{
		path: "/reporting/report/generate/:id/:reportId",
		component: ReportGenerate,
		meta: {
			requiresAuth: true,
			module: "Report",
			title: "Report Generate"
		}
	},
	{
		path: "/audit/log",
		component: AuditLog,
		meta: {
			requiresAuth: true,
			module: "Audit Log",
			title: "Audit Log",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/admin/user",
		component: UserList,
		meta: {
			requiresAuth: true,
			module: "User",
			title: "User",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/admin/user/add",
		component: UserDetails,
		meta: {
			requiresAuth: true,
			module: "User",
			title: "User Details",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/admin/user/view/:id",
		component: UserDetails,
		meta: {
			requiresAuth: true,
			module: "User",
			title: "User Details",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/admin/company",
		component: CompanyList,
		meta: {
			requiresAuth: true,
			module: "Company",
			title: "Company",
			permissions: [
				{role: "Admin"}
			]
		}
	},
	{
		path: "/admin/company/add",
		component: CompanyDetails,
		meta: {
			requiresAuth: true,
			module: "Company",
			title: "Company Details",
			permissions: [
				{role: "Admin"}
			]
		}
	},
	{
		path: "/admin/company/view/:id",
		component: CompanyDetails,
		meta: {
			requiresAuth: true,
			module: "Company",
			title: "Company Details",
			permissions: [
				{role: "Admin"}
			]
		}
	},
	{
		path: "/admin/consogroup",
		component: ConsoGroupList,
		meta: {
			requiresAuth: true,
			module: "ConsoGroup",
			title: "Conso Group",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/admin/consogroup/add",
		component: ConsoGroupDetails,
		meta: {
			requiresAuth: true,
			module: "ConsoGroup",
			title: "Conso Group Details",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/admin/consogroup/add/:companyId/:purposeId/:year/:month",
		component: ConsoGroupDetails,
		meta: {
			requiresAuth: true,
			module: "ConsoGroup",
			title: "Conso Group Details",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/admin/consogroup/view/:id",
		component: ConsoGroupDetails,
		meta: {
			requriesAuth: true,
			module: "ConsoGroup",
			title: "Conso Group Details",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/admin/purpose",
		component: PurposeList,
		meta: {
			requiresAuth: true,
			module: "Purpose",
			title: "Purpose",
			permissions: [
				{role: "Admin"}
			]
		}
	},
	{
		path: "/admin/purpose/add",
		component: PurposeDetails,
		meta: {
			requiresAuth: true,
			module: "Purpose",
			title: "Purpose Details",
			permissions: [
				{role: "Admin"}
			]
		}
	},
	{
		path: "/admin/purpose/view/:id",
		component: PurposeDetails,
		meta: {
			requiresAuth: true,
			module: "Purpose",
			title: "Purpose Details",
			permissions: [
				{role: "Admin"}
			]
		}
	},
	{
		path: "/admin/sheet/rpk",
		component: SheetList,
		meta: {
			requiresAuth: true,
			module: "RPK Sheet",
			title: "RPK Sheet",
			sheetType: "RPK",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/admin/sheet/cwk",
		component: SheetList,
		meta: {
			requiresAuth: true,
			module: "CWK Sheet",
			title: "CWK Sheet",
			sheetType: "CWK",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/admin/sheet/add/rpk",
		component: SheetDetails,
		meta: {
			requiresAuth: true,
			module: "RPK Sheet",
			title: "RPK Sheet Details",
			sheetType: "RPK",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/admin/sheet/add/cwk",
		component: SheetDetails,
		meta: {
			requiresAuth: true,
			module: "CWK Sheet",
			title: "CWK Sheet Details",
			sheetType: "CWK",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/admin/sheet/view/rpk/:id",
		component: SheetDetails,
		meta: {
			requiresAuth: true,
			module: "RPK Sheet",
			title: "RPK Sheet Details",
			sheetType: "RPK",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/admin/sheet/view/cwk/:id",
		component: SheetDetails,
		meta: {
			requiresAuth: true,
			module: "CWK Sheet",
			title: "CWK Sheet Details",
			sheetType: "CWK",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/admin/sheet/editor",
		component: TemplateEditor,
		meta: {
			layout: "blank",
			requiresAuth: true,
			module: "Sheet",
			title: "Template Editor",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/admin/account",
		component: AccountList,
		meta: {
			requiresAuth: true,
			module: "Account",
			title: "Account",
			permissions: [
				{role: "Admin"}
			]
		}
	},
	{
		path: "/admin/account/add",
		component: AccountDetails,
		meta: {
			requiresAuth: true,
			module: "Account",
			title: "Account Details",
			permissions: [
				{role: "Admin"}
			]
		}
	},
	{
		path: "/admin/account/view/:id",
		component: AccountDetails,
		meta: {
			requiresAuth: true,
			module: "Account",
			title: "Account Details",
			permissions: [
				{role: "Admin"}
			]
		}
	},
	{
		path: "/admin/country",
		component: CountryList,
		meta: {
			requiresAuth: true,
			module: "Country",
			title: "Country",
			permissions: [
				{role: "Admin"}
			]
		}
	},
	{
		path: "/admin/country/add",
		component: CountryDetails,
		meta: {
			requiresAuth: true,
			module: "Country",
			title: "Country Details",
			permissions: [
				{role: "Admin"}
			]
		}
	},
	{
		path: "/admin/country/view/:id",
		component: CountryDetails,
		meta: {
			requiresAuth: true,
			module: "Country",
			title: "Country Details",
			permissions: [
				{role: "Admin"}
			]
		}
	},
	{
		path: "/admin/currency",
		component: CurrencyList,
		meta: {
			requiresAuth: true,
			module: "Currency",
			title: "Currency",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/admin/currency/add",
		component: CurrencyDetails,
		meta: {
			requiresAuth: true,
			module: "Currency",
			title: "Currency Details",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/admin/currency/view/:id",
		component: CurrencyDetails,
		meta: {
			requiresAuth: true,
			module: "Currency",
			title: "Currency Details",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/admin/currencyexchangerate",
		component: CurrencyExchangeRate,
		meta: {
			requiresAuth: true,
			module: "CurrencyExchangeRate",
			title: "Currency Exchange Rate",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/admin/eliminationsetting",
		component: EliminationSettingList,
		meta: {
			requiresAuth: true,
			module: "EliminationSetting",
			title: "Elimination Settings",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/admin/eliminationsetting/add",
		component: EliminationSettingDetails,
		meta: {
			requiresAuth: true,
			module: "EliminationSetting",
			title: "Elimination Setting Details",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/admin/eliminationsetting/view/:id",
		component: EliminationSettingDetails,
		meta: {
			requiresAuth: true,
			module: "EliminationSetting",
			title: "Elimination Setting Details",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/admin/setting",
		component: Setting,
		meta: {
			requiresAuth: true,
			module: "Setting",
			title: "Setting",
			permissions: [
				{role: "Admin"}
			]
		}
	},
	{
		path: "/submission",
		component: Approval,
		meta: {
			requiresAuth: true,
			module: "Approval",
			title: "Financial Report Submission",
			permissions: [
				{role: "Admin"},
				{role: "HQ Staff"}
			]
		}
	},
	{
		path: "/reporting",
		redirect: "/reporting/report"
	},
	{
		path: "/audit",
		redirect: "/audit/log"
	},
	{
		path: "/admin",
		redirect: "/admin/user"
	},
	{
		path: "/",
		redirect: "home"
	},
	// otherwise redirect to home
	{path: "/:pathMatch(.*)*", redirect: "/"}
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL), // uris without hashes #, see https://router.vuejs.org/guide/essentials/history-mode.html#html5-history-mode
	routes
});

router.beforeResolve((to, from, next)=>{
	store.dispatch('setTitleModule',{'title': to.meta.title, 'module': to.meta.module});
	next();
});

router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		// this route requires auth, check if logged in
		// if not, redirect to login page.
		if (!store.getters.isLoggedIn) {
			next({
				path: "/login"
			})
		}
		
		else {
			if (store.getters.getSession.isForceUpdatePassword && to.path != "/home") {
				next({
					path: "/home"
				})
			}
			
			else {
				store.getters.error = "";
				
				let isGranted = true;
				
				const permissions = to.meta.permissions as any[];
				const roles = store.getters.getSession.roles as any[];
				if (permissions && permissions.length > 0) {
					isGranted = false;
					permissions.forEach((p) => {
						if (roles.includes(p.role)) {
							isGranted = true;
						}
					});
				}
				
				if (!isGranted) {
					store.getters.title = "Access Denied";
					store.getters.error = "403";
				}
				
				if (!(from.fullPath.startsWith(to.fullPath) || to.fullPath.startsWith(from.fullPath))) {
					store.state.cached = {page: null};
				}
				next();
			}
		}
	} 
	
	else {
		console.log('isLoggedIn: ' + store.getters.isLoggedIn);
        if (to.path == "/login" && store.getters.isLoggedIn) {
			next({
				path: "/home"
			})
		}
		
		else {
			next(); // make sure to always call next()!
		}
	}
});

export default router;